"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "players-overview"
};
const _hoisted_2 = {
    key: 0,
    class: "other_player"
};
const _hoisted_3 = {
    key: 1,
    class: "player-divider"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_overview_settings = (0, vue_1.resolveComponent)("overview-settings");
    const _component_other_player = (0, vue_1.resolveComponent)("other-player");
    const _component_player_info = (0, vue_1.resolveComponent)("player-info");
    return (_ctx.hasPlayers())
        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
            (0, vue_1.createVNode)(_component_overview_settings),
            (_ctx.thisPlayer === undefined || _ctx.players.length > 1)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getPlayersInOrder(), (otherPlayer, index) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            key: otherPlayer.color
                        }, [
                            (_ctx.thisPlayer === undefined || otherPlayer.color !== _ctx.thisPlayer.color)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_other_player, {
                                    key: 0,
                                    player: otherPlayer,
                                    playerIndex: index
                                }, null, 8, ["player", "playerIndex"]))
                                : (0, vue_1.createCommentVNode)("", true)
                        ]));
                    }), 128))
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getPlayersInOrder(), (p, index) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_player_info, {
                    player: p,
                    key: p.color,
                    playerView: _ctx.playerView,
                    firstForGen: _ctx.getIsFirstForGen(p),
                    actionLabel: _ctx.getActionLabel(p),
                    playerIndex: index
                }, null, 8, ["player", "playerView", "firstForGen", "actionLabel", "playerIndex"]));
            }), 128)),
            (_ctx.playerView.players.length > 1 && _ctx.thisPlayer !== undefined)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.thisPlayer !== undefined)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_player_info, {
                    player: _ctx.thisPlayer,
                    key: _ctx.thisPlayer.color,
                    playerView: _ctx.playerView,
                    firstForGen: _ctx.getIsFirstForGen(_ctx.thisPlayer),
                    actionLabel: _ctx.getActionLabel(_ctx.thisPlayer),
                    playerIndex: -1
                }, null, 8, ["player", "playerView", "firstForGen", "actionLabel"]))
                : (0, vue_1.createCommentVNode)("", true)
        ]))
        : (0, vue_1.createCommentVNode)("", true);
}
